/* eslint-disable react/jsx-wrap-multilines */
import React, {useEffect, useRef, useState} from 'react';
import {Controller, SubmitHandler, useForm} from 'react-hook-form';
import {
    Alert,
    Autocomplete,
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogTitle,
    Stack,
    TextField,
    Typography
} from '@mui/material';
import {useSendEmail} from "../../common/Services";
import {EmailForm} from "../../common/types";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
    CompProgList,
    DatiProg,
    FlgDMSList,
    FlgTestList,
    TipoInstList,
    TipoMigList,
    TipoProgList
} from "./types";
import {useGetDatiProgByCodProg, useUpdateDatiProg} from "./Services";
import {useGetDipendenti, useGetProgetti} from "../gestversore/Services";
import {format} from "date-fns";
import {valutaValidator} from "../../components/YupValidators";
import {Dipendenti, OpzioniItem, Progetti} from "../gestversore/types";
import VersOreNoteAssist, {clampVersOreNote, loadVersOreCopilotConfig} from "../gestversore/VersOreNoteAssist";


interface EditDatiProgProps {
  onClose: () => void;
  idprop: string;
}
const EditDatiProg: React.FC<EditDatiProgProps> = ({ onClose, idprop }) => {

const codprogprop = idprop.slice(-6);

const validationSchema = Yup.object().shape({
  id: Yup.string(),
  codprog: Yup.string(),
  ref: Yup.string(),
  refcli: Yup.string(),
  tipoprog: Yup.string(),
  compprog: Yup.string(),
  datakickoffpian: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data kickoff pianificata deve essere una data valida"),
  datakickoffeff: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data kickoff effettiva deve essere una data valida"),
  datagantt: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data Gantt deve essere una data valida"),
  datagolivepian: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data go live pianificata deve essere una data valida"),
  datagoliveeff: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data go live effettiva deve essere una data valida"),
  data1sal: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data sal 1 deve essere una data valida"),
  data2sal: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data sal 2 deve essere una data valida"),
  data3sal: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data sal 3 deve essere una data valida"),
  data4sal: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data sal 4 deve essere una data valida"),
  data5sal: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data sal 5 deve essere una data valida"),
  percomp: valutaValidator,
  tipoinst: Yup.string(),
  flgdms: Yup.string(),
  codprogdms: Yup.string(),
  datafirmakickoff: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data firma kickoff deve essere una data valida"),
  datacoll: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data colloquio deve essere una data valida"),
  note: Yup.string(),
  ditta: Yup.number().typeError("Ditta deve essere un numero"),
  tipomig: Yup.string(),
  datapercomp: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data per completamento deve essere una data valida"),
  dataagg: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data aggiornamento deve essere una data valida"),
  datatest: Yup.date().nullable().transform((v, o) => (o === "" ? undefined : v)).typeError("Data test deve essere una data valida"),

  // ricavi: valutaValidator,
});

   const [id, setId] = useState('');
   const [ditta,    setDitta] = useState(0);
   const [ref,      setRef] = useState('');
   const [tipoprog, setTipoProg] = useState('');
   const [tipomig,  setTipoMig] = useState('');
   const [tipoinst, setTipoInst] = useState('');
   const [compprog, setCompProg] = useState('');
   const [refcli,   setRefCli] = useState('');
   const [note,     setNote] = useState('');
   const [percomp,  setPerComp] = useState(0);
   const [codprogdms, setCodProgDms] = useState('');
   const [flgdms,   setFlgDms] = useState('');






  const [datakickoffpian , setDatakickoffpian	 ]=useState('');
  const [datakickoffeff  , setDatakickoffeff     ]=useState('');
  const [datagantt       , setDatagantt          ]=useState('');
  const [datagolivepian  , setDatagolivepian     ]=useState('');
  const [datagoliveeff   , setDatagoliveeff      ]=useState('');
  const [data1sal        , setData1sal           ]=useState('');
  const [data2sal        , setData2sal           ]=useState('');
  const [data3sal        , setData3sal           ]=useState('');
  const [data4sal        , setData4sal           ]=useState('');
  const [data5sal        , setData5sal           ]=useState('');
  const [datafirmakickoff, setDatafirmakickoff   ]=useState('');
  const [datacoll        , setDatacoll           ]=useState('');
  const [datapercomp     , setDatapercomp        ]=useState('');
  const [dataagg         , setDataagg            ]=useState('');
  const [datatest        , setDatatest           ]=useState('');


  const {  data:  DatiProg,  isError: isLoadingDatiProgError, isFetching: isFetchingDatiProg, isLoading: isLoadingDatiProg, } = useGetDatiProgByCodProg(codprogprop);

  const { mutateAsync: updateDatiProg, isPending: isUpdatingDatiProg } = useUpdateDatiProg();

  // solo progetti BS
  const {  data: ProgettiApiResponse } = useGetProgetti(2);

  const {  data: DipendentiApiResponse } = useGetDipendenti(2,'');

  const { setValue, register,control, handleSubmit, formState: { errors },reset,watch} = useForm({ resolver: yupResolver(validationSchema)});

  const clickedButtonRef = useRef<string | null>(null);

  const [openDialogEmailTest, setOpenDialogEmailTest] = useState(false);


   const { mutateAsync: sendEmail, isPending: isSendingEmail, isSuccess: isSuccessSendEmail } = useSendEmail();
   const [emailTo, setEmailTo] = useState(`${EMAIL_FATT_AMBIENTE_TEST}`);

useEffect(() => {
  if (DatiProg) {
    // For each field, we use handleSelection to set both the form value and the local state

    handleSelection(setDatakickoffpian, 'datakickoffpian', DatiProg?.datakickoffpian ? format(new Date(DatiProg.datakickoffpian), 'yyyy-MM-dd') : '');
    handleSelection(setDatakickoffeff, 'datakickoffeff', DatiProg?.datakickoffeff ? format(new Date(DatiProg.datakickoffeff), 'yyyy-MM-dd') : '');
    handleSelection(setDatagantt, 'datagantt', DatiProg?.datagantt ? format(new Date(DatiProg.datagantt), 'yyyy-MM-dd') : '');
    handleSelection(setDatagolivepian, 'datagolivepian', DatiProg?.datagolivepian ? format(new Date(DatiProg.datagolivepian), 'yyyy-MM-dd') : '');
    handleSelection(setDatagoliveeff, 'datagoliveeff', DatiProg?.datagoliveeff ? format(new Date(DatiProg.datagoliveeff), 'yyyy-MM-dd') : '');
    handleSelection(setData1sal, 'data1sal', DatiProg?.data1sal ? format(new Date(DatiProg.data1sal), 'yyyy-MM-dd') : '');
    handleSelection(setData2sal, 'data2sal', DatiProg?.data2sal ? format(new Date(DatiProg.data2sal), 'yyyy-MM-dd') : '');
    handleSelection(setData3sal, 'data3sal', DatiProg?.data3sal ? format(new Date(DatiProg.data3sal), 'yyyy-MM-dd') : '');
    handleSelection(setData4sal, 'data4sal', DatiProg?.data4sal ? format(new Date(DatiProg.data4sal), 'yyyy-MM-dd') : '');
    handleSelection(setData5sal, 'data5sal', DatiProg?.data5sal ? format(new Date(DatiProg.data5sal), 'yyyy-MM-dd') : '');
    handleSelection(setDatafirmakickoff, 'datafirmakickoff', DatiProg?.datafirmakickoff ? format(new Date(DatiProg.datafirmakickoff), 'yyyy-MM-dd') : '');
    handleSelection(setDatacoll, 'datacoll', DatiProg?.datacoll ? format(new Date(DatiProg.datacoll), 'yyyy-MM-dd') : '');
    handleSelection(setDatapercomp, 'datapercomp', DatiProg?.datapercomp ? format(new Date(DatiProg.datapercomp), 'yyyy-MM-dd') : '');
    handleSelection(setDataagg, 'dataagg', DatiProg?.dataagg ? format(new Date(DatiProg.dataagg), 'yyyy-MM-dd') : '');

    handleSelection(setId, 'id', DatiProg?.id || 0);
    handleSelection(setDitta, 'ditta', DatiProg?.ditta || 0);
    handleSelection(setRef, 'ref', DatiProg?.ref || '');
    handleSelection(setTipoProg, 'tipoprog', DatiProg?.tipoprog || '');
    handleSelection(setTipoMig, 'tipomig', DatiProg?.tipomig || '');
    handleSelection(setTipoInst, 'tipoinst', DatiProg?.tipoinst || '');
    handleSelection(setCompProg, 'compprog', DatiProg?.compprog || '');
    handleSelection(setRefCli, 'refcli', DatiProg?.refcli || '');
    handleSelection(setNote, 'note', DatiProg?.note || '');
    handleSelection(setPerComp, 'percomp', DatiProg?.percomp || 0);
    handleSelection(setCodProgDms, 'codprogdms', DatiProg?.codprogdms || '');
    handleSelection(setFlgDms, 'flgdms', DatiProg?.flgdms || '');
    handleSelection(setDatatest, 'datatest', DatiProg?.datatest ? format(new Date(DatiProg.datatest), 'yyyy-MM-dd') : '');

  }
}, [DatiProg]);


   const role = localStorage.getItem('keyrole') || '';

   let isdatiprogettoadmin = false;

   if (role.includes('TimeReportAdmin') || role.includes('TimeReportDatiProgetto') ) {
       isdatiprogettoadmin = true;
   };


   const progettoCorrente = ProgettiApiResponse?.results.find(  (item: Progetti) => item.codprog?.trim() === codprogprop.trim());
   const desprog = progettoCorrente?.desprog || '';


// const handleSelection = (setter: (value: any) => void, fieldName: any, value: any) => {
//     // console.log('handleSelection called with:', value);
//     if (value) {
//           // console.log('Setting field:', fieldName, 'with value:', value);
//         setValue(fieldName, value); //  ************ set  form state
//         setter(value); // set the local state and
//     }
//     // console.log('values of form ', watch());
// };

const handleSelection = (setter: (value: any) => void, fieldName: any, value: any) => {
    setValue(fieldName, value);
    setter(value);
};



const handleEmail = async () => {
  const emailForm: EmailForm = {
    email: emailTo || '',
    subject: `Fatturare Attivazione ambiente test progetto: ${desprog}`,
    message: 'Vedi Oggetto',
    attachment: '',
    tipo: 'generico',
  };

  await sendEmail(emailForm);

  const today = format(new Date(), 'yyyy-MM-dd');

  handleSelection(setDatatest, 'datatest', today);

  handleSubmit(onSubmitEmailTest)();
};




 const handleClose = () => {
            onClose();
          };


const onSubmitEmailTest: SubmitHandler<DatiProg> = async (data) => {
    const copilotConfig = await loadVersOreCopilotConfig();
    await updateDatiProg({
        ...data,
        // note: clampVersOreNote(data.note || '', copilotConfig.noteMaxLength).value,
    });
};


const onSubmit: SubmitHandler<DatiProg> = async (data) => {
    const copilotConfig = await loadVersOreCopilotConfig();
    await updateDatiProg({
        ...data,
         ditta: 2,
        // note: clampVersOreNote(data.note || '', copilotConfig.noteMaxLength).value,
    });
    onClose();
};


  return (

 // <Box sx={{mt: '100px' , ml:10, width: '75%'  }}>
    <Dialog onClose={onClose} open fullWidth maxWidth="lg">
    <DialogTitle>
        {/*<Typography variant="h2">Nuovo</Typography>*/}
    </DialogTitle>
        <DialogContent>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Stack spacing={2} direction="column" alignItems="flex-start">
                    <Stack direction="row" spacing={2} sx={{width: '100%'}}>
                        <Box sx={{width: '25%'}}>
                            <TextField
                                id="dataagg"
                                type="date"
                                label="Data Agg.Prog."
                                fullWidth margin="dense"
                                {...register('dataagg')}
                                value={dataagg}
                                onChange={(e) => setDataagg(e.target.value)}
                                error={!!errors.dataagg}
                            />
                            <Typography variant="caption" color="error">{errors.dataagg?.message}</Typography>
                        </Box>
                       <Box sx={{ width: '100%' }}>
                              <TextField
                                      id="id"
                                      label="Progetto"
                                      fullWidth
                                      margin="dense"
                                      disabled
                                      value={desprog}
                                    />
                              {/*<TextField*/}
                              {/*  id="id"*/}
                              {/*  label="Progetto"*/}
                              {/*  fullWidth*/}
                              {/*  margin="dense"*/}
                              {/*  disabled*/}
                              {/*  value={ProgettiApiResponse?.results.find((item: Progetti) => item.codprog?.trim() === codprogprop.trim())?.desprog || '' }*/}

                              {/*  // value={ProgettiApiResponse?.results.find((item: Progetti) => {console.log(item.idprog?.trim()); item.idprog?.trim() === id.trim()}) || ''}*/}

                              {/*          // /!*{...register('id')} error={!!errors.id}*!/*/}
                              {/*/>*/}
                              {/*/!* <Typography variant="caption" color="error">{errors.id?.message}</Typography> *!/*/}
                           </Box>

                        <Box sx={{width: '25%'}}>
                            <TextField
                                id="percomp"
                                label="Perc.Comp"
                                fullWidth margin="dense"
                                {...register('percomp')}
                                // value={percomp}
                                error={!!errors.percomp}
                            />
                            <Typography variant="caption" color="error">{errors.percomp?.message}</Typography>
                        </Box>
                         <Box sx={{width: '25%'}}>
                            <TextField
                                id="datapercomp"
                                type="date"
                                label="Data Perc.Comp."
                                fullWidth margin="dense"
                                {...register('datapercomp')}
                                value={datapercomp}
                                onChange={(e) => setDatapercomp(e.target.value)}
                                error={!!errors.datapercomp}
                            />
                            <Typography variant="caption" color="error">{errors.datapercomp?.message}</Typography>
                        </Box>
                       </Stack>
                    <Stack direction="row" spacing={2} sx={{width: '100%'}}>
                        <Box sx={{ width: '40%' }}>
                            <Autocomplete
                                disablePortal
                                id="ref"
                                // value={DipendentiApiResponse?.results.find((item: Dipendenti) => (item.coddip || '').trim() === ref.trim()) || null}
                                value={DipendentiApiResponse?.results.find((item: Dipendenti) => (item.coddip || '').trim() === (ref || '').trim()  ) || null}
                                options={DipendentiApiResponse?.results ?? []}
                                // onChange={(event, value) => {handleSelection(setRef, 'ref', value?.coddip);handleSelection(setDitta, 'ditta', value?.codditta);}}
                                onChange={(event, value) => {handleSelection(setRef, 'ref', value?.coddip || ''); handleSelection(setDitta, 'ditta', value?.codditta || 0);
}}
                                renderInput={(params) => <TextField {...params} margin="dense" label="Seleziona Ref.Interno" fullWidth />}
                            />
                                <Typography variant="caption" color="error">{errors.ref?.message}</Typography>
                        </Box>

                        <Box sx={{width: '40%'}}>
                            <TextField
                                id="refcli"
                                label="Ref.Cliente"
                                fullWidth margin="dense"
                                {...register('refcli')}
                                value={refcli}
                                onChange={(e) => handleSelection(setRefCli, 'refcli', e.target.value)}
                                error={!!errors.refcli}
                            />
                            <Typography variant="caption" color="error">{errors.refcli?.message}</Typography>
                        </Box>
                        {tipomig === 'ALYANTE' && (
                          <>
                            {(!datatest || datatest === '') ? (
                              <>
                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '10%' }}>
                                  {/* empty box if you need spacing */}
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '10%' }}>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleEmail}
                                    sx={{ py: 1, fontSize: '0.60rem' }}
                                  >
                                    Invia Email Fatt. Attiv. Ambiente Test
                                  </Button>
                                </Box>
                              </>
                            ) : (
                              <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '15%' }}>
                                <Typography
                                  variant="caption"
                                  sx={{ py: 2, fontSize: '0.70rem', color: 'red' }}
                                >
                                  Email Fatt Ambiente Test inviata il: {datatest}
                                </Typography>
                              </Box>
                            )}
                          </>
                        )}
                        {/*<Box sx={{width: '33%'}}>*/}
                       {/*    <Autocomplete*/}
                       {/*         disablePortal*/}
                       {/*         id="flgtest"*/}
                       {/*         value={FlgTestList.find((item: OpzioniItem) => item.id === flgtest) || null}*/}
                       {/*         options={FlgTestList}*/}
                       {/*          onChange={(event, value) => {*/}
                       {/*                   handleSelection(setFlgTest, 'flgtest', value?.id);*/}
                       {/*                   if (value?.id === 'S') { setOpenDialogEmailTest(true); }*/}
                       {/*                 }}*/}
                       {/*         renderInput={(params) => <TextField {...params} margin="dense" label="Attivaz.Ambiente Test" fullWidth />}*/}
                       {/*         />*/}
                       {/*     <Typography variant="caption" color="error">{errors.flgtest?.message}</Typography>*/}
                       {/* </Box>*/}
                       {/*{isdatiprogettoadmin && (*/}
                       {/*  <Box sx={{width: '20%'}}>*/}
                       {/*     <TextField*/}
                       {/*         id="ricavi"*/}
                       {/*         label="Ricavi"*/}
                       {/*         fullWidth margin="dense"*/}
                       {/*         {...register('ricavi')}*/}
                       {/*         // value={ricavi}*/}
                       {/*         error={!!errors.ricavi}*/}

                       {/*     />*/}
                       {/*     <Typography variant="caption" color="error">{errors.ricavi?.message}</Typography>*/}
                       {/* </Box>)}*/}


                    </Stack>
                    <Stack direction="row" spacing={2} sx={{width: '100%'}}>
                        <Box sx={{width: '33%'}}>
                            <Autocomplete
                                disablePortal
                                id="tipoprog"
                                value={TipoProgList.find((item: OpzioniItem) => item.id === tipoprog) || null}
                                options={TipoProgList}
                                onChange={(event, value) => {handleSelection(setTipoProg, 'tipoprog', value?.id)}}
                                renderInput={(params) => <TextField {...params} margin="dense" label="Seleziona Tipo Prog" fullWidth />}
                                />
                            <Typography variant="caption" color="error">{errors.tipoprog?.message}</Typography>
                        </Box>
                          <Box sx={{width: '33%'}}>
                           <Autocomplete
                                disablePortal
                                id="tipomig"
                                value={TipoMigList.find((item: OpzioniItem) => item.id === tipomig) || null}
                                options={TipoMigList}
                                onChange={(event, value) => {handleSelection(setTipoMig, 'tipomig', value?.id)}}
                                renderInput={(params) => <TextField {...params} margin="dense" label="Seleziona Tipo Mig" fullWidth />}
                                />
                            <Typography variant="caption" color="error">{errors.tipomig?.message}</Typography>
                        </Box>
                        <Box sx={{width: '33%'}}>
                            <Autocomplete
                                disablePortal
                                id="tipoinst"
                                value={TipoInstList.find((item: OpzioniItem) => item.id === tipoinst) || null}
                                options={TipoInstList}
                                onChange={(event, value) => {handleSelection(setTipoInst, 'tipoinst', value?.id)}}
                                renderInput={(params) => <TextField {...params} margin="dense" label="Seleziona Tipo Inst" fullWidth />}
                                />
                            <Typography variant="caption" color="error">{errors.tipoinst?.message}</Typography>
                        </Box>
                     </Stack>
                    <Stack direction="row" spacing={2} sx={{width: '100%'}}>
                        <Box sx={{width: '33%'}}>
                           <Autocomplete
                                disablePortal
                                id="compprog"
                                // value={opzione}
                               value={CompProgList.find((item: OpzioniItem) => item.id === compprog) || null}
                                options={CompProgList}
                                onChange={(event, value) => {handleSelection(setCompProg, 'compprog', value?.id)}}
                                renderInput={(params) => <TextField {...params} margin="dense" label="Seleziona Comp. Prog." fullWidth />}
                                />
                            <Typography variant="caption" color="error">{errors.compprog?.message}</Typography>
                        </Box>
                        <Box sx={{width: '33%'}}>
                           <Autocomplete
                                disablePortal
                                id="flgdms"
                                value={FlgDMSList.find((item: OpzioniItem) => item.id === flgdms) || null}
                                options={FlgDMSList}
                                onChange={(event, value) => {handleSelection(setFlgDms, 'flgdms', value?.id)}}
                                renderInput={(params) => <TextField {...params} margin="dense" label="Seleziona Flg DMS" fullWidth />}
                                />
                            <Typography variant="caption" color="error">{errors.flgdms?.message}</Typography>
                        </Box>
                        <Box sx={{width: '33%'}}>
                            <TextField
                                id="codprogdms"
                                label="Cod Progetto DMS"
                                fullWidth margin="dense"
                                {...register('codprogdms')}
                                value={codprogdms}
                                onChange={(e) => handleSelection(setCodProgDms, 'codprogdms', e.target.value)}
                                error={!!errors.codprogdms}
                            />
                            <Typography variant="caption" color="error">{errors.codprogdms?.message}</Typography>
                        </Box>
                     </Stack>
                    <Stack direction="row" spacing={2} sx={{width: '100%'}}>
                      <Box sx={{width: '33%'}}>
                            <TextField
                                id="datafirmakickoff"
                                type="date"
                                label="Data Kickoff Firma"
                                fullWidth margin="dense"
                                {...register('datafirmakickoff')}
                                value={datafirmakickoff}
                                onChange={(e) => setDatafirmakickoff(e.target.value)}
                                error={!!errors.datafirmakickoff}
                            />
                            <Typography variant="caption" color="error">{errors.datafirmakickoff?.message}</Typography>
                        </Box>
                        <Box sx={{width: '33%'}}>
                            <TextField
                                id="datakickoffpian"
                                type="date"
                                label="Data Kickoff Pian."
                                fullWidth margin="dense"
                                {...register('datakickoffpian')}
                                value={datakickoffpian}
                                onChange={(e) => setDatakickoffpian(e.target.value)}
                                error={!!errors.datakickoffpian}
                            />
                            <Typography variant="caption" color="error">{errors.datakickoffpian?.message}</Typography>
                        </Box>
                        <Box sx={{width: '33%'}}>
                            <TextField
                                id="datakickoffeff"
                                type="date"
                                label="Data Kickoff Eff."
                                fullWidth margin="dense"
                                {...register('datakickoffeff')}
                                value={datakickoffeff}
                                onChange={(e) => setDatakickoffeff(e.target.value)}
                                error={!!errors.datakickoffeff}
                            />
                            <Typography variant="caption" color="error">{errors.datakickoffeff?.message}</Typography>
                        </Box>
                        </Stack>
                    <Stack direction="row" spacing={2} sx={{width: '100%'}}>
                        <Box sx={{width: '33%'}}>
                            <TextField
                                id="datagantt"
                                type="date"
                                label="Data Gantt"
                                fullWidth margin="dense"
                                {...register('datagantt')}
                                value={datagantt}
                                onChange={(e) => setDatagantt(e.target.value)}
                                error={!!errors.datagantt}
                            />
                            <Typography variant="caption" color="error">{errors.datagantt?.message}</Typography>
                        </Box>
                        <Box sx={{width: '33%'}}>
                            <TextField
                                id="datagolivepian"
                                type="date"
                                label="Data GoLive Pian."
                                fullWidth margin="dense"
                                {...register('datagolivepian')}
                                value={datagolivepian}
                                onChange={(e) => setDatagolivepian(e.target.value)}
                                error={!!errors.datagolivepian}
                            />
                            <Typography variant="caption" color="error">{errors.datagolivepian?.message}</Typography>
                        </Box>
                        <Box sx={{width: '33%'}}>
                            <TextField
                                id="datagoliveeff"
                                type="date"
                                label="Data GoLive Eff."
                                fullWidth margin="dense"
                                {...register('datagoliveeff')}
                                value={datagoliveeff}
                                onChange={(e) => setDatagoliveeff(e.target.value)}
                                error={!!errors.datagoliveeff}
                            />
                            <Typography variant="caption" color="error">{errors.datagoliveeff?.message}</Typography>
                        </Box>
                        </Stack>
                    <Stack direction="row" spacing={2} sx={{width: '100%'}}>
                        <Box sx={{width: '20%'}}>
                            <TextField
                                id="data1sal"
                                type="date"
                                label="Data Sal 1"
                                fullWidth margin="dense"
                                {...register('data1sal')}
                                value={data1sal}
                                onChange={(e) => setData1sal(e.target.value)}
                                error={!!errors.data1sal}
                            />
                            <Typography variant="caption" color="error">{errors.data1sal?.message}</Typography>
                        </Box>
                        <Box sx={{width: '20%'}}>
                            <TextField
                                id="data2sal"
                                type="date"
                                label="Data Sal 2"
                                fullWidth margin="dense"
                                {...register('data2sal')}
                                value={data2sal}
                                onChange={(e) => setData2sal(e.target.value)}
                                error={!!errors.data2sal}
                            />
                            <Typography variant="caption" color="error">{errors.data2sal?.message}</Typography>
                        </Box>

                        <Box sx={{width: '20%'}}>
                            <TextField
                                id="data3sal"
                                type="date"
                                label="Data Sal 3"
                                fullWidth margin="dense"
                                {...register('data3sal')}
                                value={data3sal}
                                onChange={(e) => setData3sal(e.target.value)}
                                error={!!errors.data3sal}
                            />
                            <Typography variant="caption" color="error">{errors.data3sal?.message}</Typography>
                        </Box>
                        <Box sx={{width: '20%'}}>
                            <TextField
                                id="data4sal"
                                type="date"
                                label="Data Sal 4"
                                fullWidth margin="dense"
                                {...register('data4sal')}
                                value={data4sal}
                                onChange={(e) => setData4sal(e.target.value)}
                                error={!!errors.data4sal}
                            />
                            <Typography variant="caption" color="error">{errors.data4sal?.message}</Typography>
                        </Box>
                        <Box sx={{width: '20%'}}>
                            <TextField
                                id="data5sal"
                                type="date"
                                label="Data Sal 5"
                                fullWidth margin="dense"
                                {...register('data5sal')}
                                value={data5sal}
                                onChange={(e) => setData5sal(e.target.value)}
                                error={!!errors.data5sal}
                            />
                            <Typography variant="caption" color="error">{errors.data5sal?.message}</Typography>
                        </Box>
                         <Box sx={{width: '20%'}}>
                            <TextField
                                id="datacoll"
                                type="date"
                                label="Data Coll."
                                fullWidth margin="dense"
                                {...register('datacoll')}
                                value={datacoll}
                                onChange={(e) => setDatacoll(e.target.value)}
                                error={!!errors.datacoll}
                            />
                            <Typography variant="caption" color="error">{errors.datacoll?.message}</Typography>
                        </Box>
                    </Stack>

                    <Stack direction="row" spacing={2} sx={{width: '100%'}}>
                    <Box sx={{width: '100%'}}>
                        <Controller
                            name="note"
                            control={control}
                            render={({ field, fieldState }) => (
                                <VersOreNoteAssist
                                    textFieldId="dati-prog-edit-note"
                                    value={String(field.value || '')}
                                    onChange={field.onChange}
                                    error={!!fieldState.error}
                                    helperText={fieldState.error?.message}
                                    rows={3}
                                    maxLength={2000}
                                />
                            )}
                        />
                    </Box>
                    </Stack>

                    <Stack direction="row"  justifyContent="flex-end" spacing={1}  sx={{ marginTop: '15px', alignSelf: 'flex-end', width: '100%' }}>
                        <Button color="primary" type="reset" variant="outlined">CANCELLA</Button>
                        <Button variant="contained" onClick={onClose} color="error">CHIUDI</Button>
                        <Button
                            id="save"
                            type="submit"
                            color="primary"
                            variant="contained"
                            disabled={isUpdatingDatiProg}
                            startIcon={isUpdatingDatiProg ? <CircularProgress color="inherit" size={25}/> : null}
                            // onClick={() => handleButtonClick('save')}
                            >
                            SALVA
                        </Button>
                    </Stack>
                </Stack>
            </form>


        </DialogContent>
    </Dialog>

  );
};

export default EditDatiProg;
